<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <button type="button" class="btn btn-secondary btn-block" (click)="IrOperativoChv()" style="overflow: hidden; white-space: normal; max-width: 100%;">Cartera Hipotecaria de Vivienda</button>
    </div>
  </div>
  <div class="row">
    <div class="col-3" style="text-align: left; margin: 5px;">
      <div class="btn-group dropright btn-block">
        <button class="btn btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-expanded="false" style="overflow: hidden; white-space: normal; max-width: 100%;">
          Financiación de Vivienda
        </button>
        <ul class="dropdown-menu">
          <li><a class="dropdown-item" (click)="IrOperativoFivi()">Operativo mensual</a></li>
          <li><a class="dropdown-item" (click)="IrOperativoFiviTrimestral()">Operativo trimestral</a></li>
        </ul>
      </div>
    </div>
  </div>
</body>
